import { parse } from "date-fns";

export abstract class JamezzTableField {
  public dbfield: string;
  public name: string;
  public editable: boolean;
  public inputtype: string | null;
  public inputProps: object = {};
  public type: string = "text";

  constructor(dbfield: string, editable: boolean) {
    this.dbfield = dbfield;
    this.name = dbfield;
    this.editable = editable;
    this.inputtype = null;
  }
}
export class JamezzTableDateField extends JamezzTableField {
  public customRender: Function | undefined = undefined;
  public nullable: boolean;

  public customData = (object: any): any => {
    if (object[this.dbfield] == null) {
      return null;
    }

    return object[this.dbfield];
  };

  constructor(
    dbfield: string,
    editable: boolean,
    nullable: boolean = false,
    name = null,
    customData = null,
    customRender = null
  ) {
    super(dbfield, editable);
    this.inputtype = "ControlledInput";
    this.type = "date";
    this.nullable = nullable;
    this.name = name ?? dbfield;
    if (customData != null) {
      // @ts-ignore
      this.customData = customData;
    }
    if (customRender) {
      // @ts-ignore
      this.customRender = customRender;
    }
    if (!editable) {
      this.customRender = (datetime: string | null) => {
        if (datetime == null) {
          return "-";
        }

        return parse(datetime, "yyyy-MM-dd", new Date()).toLocaleDateString();
      };
    }
  }
}

export class JamezzTableValuta extends JamezzTableField {
  public customRender: Function | undefined = undefined;
  public nullable: boolean;

  constructor(dbfield: string, editable: boolean, nullable: boolean = false) {
    super(dbfield, editable);
    this.inputtype = "ControlledInput";
    this.type = "currency";
    this.nullable = nullable;
    if (!editable) {
      this.customRender = (amount: number) => {
        const formatter = new Intl.NumberFormat("nl-NL", {
          style: "currency",
          currency: "EUR",
          currencyDisplay: "symbol",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });

        return formatter.format(amount);
      };
    }
  }
}

export class JamezzTableLinkToRelation extends JamezzTableField {
  readonly inputtype: string;
  public url: string;
  public urlData: {};

  constructor(dbfield: string, url: string, urlData: {}) {
    super(dbfield, true);
    this.inputtype = "Link";
    this.url = url;
    this.urlData = urlData;
  }
}
